module.exports = __webpack_public_path__ + "assets/f39eefaf10a7400ce789889ff9340dd9.svg";